import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
// Configure Firebase.
const config = {
  apiKey: process.env.REACT_APP_FIREBASEAPIKEY,
  authDomain: process.env.REACT_APP_FIREBASEAUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASEPROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASESTORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASEMESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASEAPPID,
  databaseURL: process.env.REACT_APP_REALTIMEDATABASE_URL
};
//firebase.initializeApp(config);

const firebaseApp = firebase.initializeApp(config);

// Realtime Database is intentionally NOT initialized here — only LandingPageNew.js
// (the /ask-vasi route) uses it, and importing `firebase/database` here would pull
// its client (including its persistent-connection code) into every page's shared
// bundle. LandingPageNew.js imports `getDatabase`/`firebaseApp` directly instead, so
// that code stays scoped to its own lazy-loaded chunk.

export {firebaseApp};
//export default firebase;